export default "__VITE_PUBLIC_ASSET__c77399a2__"